export const STOCK_UNITS_SET = 'STOCK_UNITS_SET'
export const STOCK_UNITS_FETCHING = 'STOCK_UNITS_FETCHING'
